module.exports = __webpack_public_path__ + "static/media/w.1aef99fe.svg";